import RESTApiEndPoints from "./rest-api-end-points";
import IPort from "@/models/port";
import axiosService from "@/services/axios-service";
import IPortSearchArgs from "@/models/portSearchArgs";
import IResponse from "@/models/response";
import { AxiosResponse } from "axios";

export default class PortsService {
  public async get() {
    const result = await axiosService.get<IPort[]>(RESTApiEndPoints.portsUrl());
    return result.data as IPort[];
  }

  public async search(args: IPortSearchArgs): Promise<AxiosResponse<any>> {
    return axiosService.post(`${RESTApiEndPoints.portsUrl()}/search`, args);
  }

  public async getById(id: number) {
    const response = await axiosService.get<IPort>(`${RESTApiEndPoints.portsUrl()}/${id}`);
    return response.data;
  }

  public async getByManyId(ids: number[]) {
    const response = await axiosService.post<IPort[]>(`${RESTApiEndPoints.portsUrl()}/many`, ids);
    return response.data;
  }
  public async delete(id: number) {
    const response = await axiosService.delete(`${RESTApiEndPoints.portsUrl()}/${id}`);
    return response;
  }
  public async update(obj: IPort) {
    if (obj.id) {
      return axiosService.put(`${RESTApiEndPoints.portsUrl()}`, obj);
    } else {
      return axiosService.post(`${RESTApiEndPoints.portsUrl()}`, obj);
    }
  }

  public async searchByName(portName: string) {
    return (
      await axiosService.post<IResponse<IPort>>(`${RESTApiEndPoints.portsUrl()}/search`, {
        keyword: portName,
        pagingOptions: {
          currentPage: 1,
          pageSize: 10
        }
      } as IPortSearchArgs)
    ).data;
  }
}
